/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
export const USER_ROLES = {
  MEDIA_VIEW: "MEDIA_VIEW",
};
